<template>
  <form
    :method="methodType"
    accept-charset="UTF-8"
    autocomplete="off"
    :action="actionUrl"
    id="emailForm"
    :reset="true"
    v-on:submit.prevent="submit"
  >
    <email-nav
      v-if="!isNewsletter && emailId"
      :emailId="emailId"
    />

    <newsletter-nav
      v-if="isNewsletter && emailId"
      :newsletterId="emailId"
    />

    <div
      v-if="!base.loading"
    >
      <h2>{{ modelAction }} {{ title }} {{ emailId ? `#${emailId}` : '' }}</h2>

      <div
        class="form-group"
        v-if="!isNewsletter"
      >
        <label :for="modelInputId('display_name')">
          Email Name
        </label>
        <input
          type="text"
          :name="modelInputName('display_name')"
          :id="modelInputId('display_name')"
          v-model="email.display_name"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label :for="modelInputId('subject')">
          Subject
        </label>
        <input
          type="text"
          :name="modelInputName('subject')"
          :id="modelInputId('subject')"
          v-model="email.subject"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label :for="modelInputId('html-text')">
          HTML-Formatted Text
        </label>

        <textarea
          :name="modelInputName('html_text')"
          :id="modelInputId('html-text')"
          v-model="email.html_text"
          class="form-control"
          rows="15"></textarea>

        <fieldset
          v-if="showEmbedHTMLOptions"
          class="text-right mt-1 mb-2"
        >
          <button
            class="btn btn-primary btn-sm"
            :data-text-ele="modelInputId('html-text')"
            v-on:click.prevent="addPuzzlePlayerLink"
          >
            Add Puzzle Player Link
          </button>
        </fieldset>

        <div class="alert alert-warning text-center" role="alert">
          Emails are embedded in a pre-existing HTML template,
          so any &lt;html&gt; or &lt;head&gt; elements will not be displayed.
        </div>
      </div>

      <div class="form-group">
        <label :for="modelInputId('sender')">
          Sender Email:
        </label>

        <input
          type="text"
          :name="modelInputName('sender_email')"
          :id="modelInputId('sender')"
          v-model="sender"
          :placeholder="defaultEmail"
          class="form-control"
        />
      </div>

      <div
        class="form-group"
        v-if="isNewsletter"
      >
        <newsletter-type-picker
          :newsletterTypeId="email.newsletter_type_id"
          showStatus
        ></newsletter-type-picker>
        <!-- // Provider selection is now assigned by attached puzzles
        <provider-picker
          :providerId="email.puzzle_link_id"
          label="Puzzle Type"
          selectName="newsletter[puzzle_link_id]"
          v-if="!email.digest"
        ></provider-picker>
        -->
      </div>

      <div class="form-group">
        <fieldset>
          <legend>Options</legend>

          <div class="row">
            <div class="col-md-6">
              <label :for="modelInputId('send-at')">
                Send at
              </label>

              <div class="input-group">
                <input
                  type="date"
                  name="send_at_date"
                  :id="modelInputId('send-at-date')"
                  ref="sendAtDate"
                  class="form-control"
                  :value="send_at_date"
                  v-on:change="setSendAt"
                />

                <input
                  type="time"
                  name="send_at_time"
                  :id="modelInputId('send-at-time')"
                  class="form-control"
                  ref="sendAtTime"
                  :value="send_at_time"
                  v-on:change="setSendAt"
                />

              </div>
              <div>
                <input
                  type="hidden"
                  :name="modelInputName('send_at')"
                  :id="modelInputId('send-at')"
                  v-model="email.send_at"
                />
              </div>

              <div class="alert alert-warning text-center" role="alert">
                <p>
                  Please note that the <cite>send at</cite> time is set to your local time zone.
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <label :for="modelInputId('inactive')">
                <input
                  type="hidden"
                  :name="modelInputName('inactive')"
                  value="false"
                />
                <input
                  type="checkbox"
                  :id="modelInputId('inactive')"
                  :name="modelInputName('inactive')"
                  v-model="email.inactive"
                />
                Draft?
              </label>

              <br />

              <input
                type="hidden"
                :id="modelInputId('inactive')"
                :name="modelInputName('inactive')"
                v-model="email.inactive"
              />
              <div
                v-if="email.newsletter_type"
              >
                <input
                  type="hidden"
                  :name="modelInputName('subscribers_only')"
                  v-model="email.newsletter_type.attributes.requires_subscription"
                />
              </div>
              <!-- TEMP: replace when criteria is universal -->
              <div
                v-else
              >
                <label for="all-users">
                  <input
                    type="checkbox"
                    id="all-users"
                    :name="modelInputName('criteria]all_users')"
                    value="all"
                    v-model="email.all_users"
                  />
                  All Users?
                </label>

                <input
                  type="hidden"
                  :name="modelInputName('criteria][all_users')"
                  v-model="email.all_users"
                />

                <br />

                <label for="subscribers-only">
                  <input
                    type="checkbox"
                    id="subscribers-only"
                    :name="modelInputName('subscribers_only')"
                    value="subscribers_only"
                    v-model="email.subscribers_only"
                  />
                  Subscribers Only?
                </label>

                <input
                  type="hidden"
                  :name="modelInputName('subscribers_only')"
                  v-model="email.subscribers_only"
                />
              </div>
            </div>
          </div>
        </fieldset>

      </div>

      <hr />

      <email-criteria-form
        :criteria="email.criteria"
        v-if="isEmail"
      />

      <div id="accordion">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button
                type="button"
                :class="attachBtnClasses"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Puzzles <span class="badge badge-primary">{{ email.puzzles ? email.puzzles.length : 0 }}</span>
              </button>
            </h5>
          </div>

          <div id="collapseOne" :class="attachClasses" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="card-body">

              <puzzle-search />

              <hr />

              <div
                id="puzzles"
                v-if="email.puzzles && email.puzzles.length"
              >
                <h4>
                  Attached Puzzles
                </h4>
                <ol>
                  <li v-for="puzzle in email.puzzles">
                    <router-link
                      :to="{
                        name: 'puzzle',
                        params: {
                          puzzleId: puzzle.id
                        }
                      }"
                      v-bind:class="{ pending: puzzle.pending }"
                    >
                      Puzzle {{ puzzle.name }} (#{{ puzzle.id }})
                    </router-link>

                    <span
                      class="btn btn-sm btn-danger mt-1 mb-1"
                      v-on:click="detachPuzzle(puzzle)"
                    >
                      Detach Puzzle
                    </span>
                    <input
                      type="hidden"
                      :name="modelInputName((isNewsletter ? 'newsletter' : 'email') + '_puzzles_attributes') + '[][puzzle_id]'"
                      :value="puzzle.id"
                    />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h5 class="mb-0">
              <button
                type="button"
                :class="attachBtnClasses"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
              >
                Attachments
                <span class="badge badge-primary">{{ email.attachments ? email.attachments.length : 0 }}</span>
              </button>
            </h5>
          </div>

          <div id="collapseTwo" :class="attachClasses" aria-labelledby="headingTwo" data-parent="#accordion">
            <div class="card-body">

              <p class="alert alert-warning text-center" role="alert">
                Attachments are for including supplemental images and files separate from the attached puzzles.
              </p>

              <ol v-if="attachments">
                <li v-for="attachment in attachments">
                  {{ attachment.filename }}

                  <label>
                    Delete?
                  </label>
                  <input
                    type="checkbox"
                    :name="modelInputName('delete_attachments') + '[]'"
                    :value="attachment.id"
                  />
                </li>
              </ol>

              <div :id="modelInputId('attachments')">
                <label :for="modelInputId('attachment')">
                  Add an Attachment
                    <button class="btn btn-default" v-on:click="newAttachment">
                      <strong>+</strong>
                    </button>
                </label>
                <div>
                  <input
                    type="file" :name="modelInputName('attachment_files') + '[]'"
                    :class="modelInputId('attachment')"
                    style="display: none;"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <input
          type="hidden"
          :name="modelInputName('id')"
          v-model="email.id"
        />
        <button
          type="submit"
          class="form-control btn btn-primary"
        >
          {{ ( emailId ? 'Edit' : 'Create' ) + ` ${ displayActionStatus } ${ title }` }}
        </button>
      </div>
    </div>
    <spinner
      v-else
      size="huge"
    />
    <email-draft
      :emailId="emailId"
      :newsletterId="newsletterId"
      :email="email"
      v-if="!isNewsletter"
      hidePublish
    />
  </form>
</template>
<script>
import Spinner from 'vue-simple-spinner'

import NewsletterMixin from '@/mixins/NewsletterMixin'
import NewsletterTypesMixin from '@/mixins/NewsletterTypesMixin'

import NewsletterNav from '@/components/NewsletterNav'
import NewsletterTypePicker from '@/components/NewsletterTypePicker'

import ProviderPicker from '@/components/ProviderPicker'

import EmailCriteriaForm from '@/components/EmailCriteriaForm'
import EmailDraft from '@/components/EmailDraft'
import EmailNav from '@/components/EmailNav'
import PuzzleSearch from '@/components/PuzzleSearch'

import EmailMixin from '@/mixins/EmailMixin'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  computed: mapState({
    actionUrl () {
      return this.apiUrl('/' + this.emailType + 's' + (this.emailId ? ('/' + this.emailId) : ''), true)
    },

    attachBtnClasses () {
      return `btn btn-link ${this.hasAttachments ? 'collapsed' : ''}`
    },

    attachClasses () {
      return `collapse ${this.hasAttachments ? 'show' : ''}`
    },

    defaultEmail () {
      return this.isNewsletter ? this.email.newsletter_type.attributes.default_reply_email : this.email.sender_email
    },

    displayStatus () {
      return this.inactive ? 'Draft' : ''
    },

    hasAttachments () {
      return this.attachments && this.attachments.length
    },

    methodType () {
      return this.emailId ? 'PUT' : 'POST'
    },

    modelAction () {
      return this.emailId ? 'Edit' : 'Create'
    },

    modelPrefix () {
      return this.modelType + '_'
    },

    paramIdName () {
      return this.emailType + 'Id'
    },

    now () {
      const d = this.getLocalDateTimeAt()

      return this.$root.pretty12HourMinFmt(d)
    },

    sender () {
      return this.email.sender_email || this.defaultEmail
    },

    today () {
      const d = this.getLocalDateTimeAt()

      return this.$root.prettyDateFmt(d)
    },

    send_at_date () {
      const d = this.getLocalDateTimeAt(this.email.send_at)

      return this.$root.localDateInputFmt(d)
    },

    send_at_time () {
      const d = this.getLocalDateTimeAt(this.email.send_at)

      return this.$root.localTimeInputFmt(d)
    },

    settings () {
      return this.$store.getters['SettingModule/settingsObject']
    },

    showEmbedHTMLOptions () {
      return this.email.puzzles.length && !!this.settings['embedded_puzzle_player_in_newsletters']
    }
  }),

  components: {
    'email-criteria-form': EmailCriteriaForm,
    'email-draft': EmailDraft,
    'email-nav': EmailNav,
    'newsletter-nav': NewsletterNav,
    'newsletter-type-picker': NewsletterTypePicker,
    'provider-picker': ProviderPicker,
    'puzzle-search': PuzzleSearch,
    'spinner': Spinner
  },

  mixins: [
    EmailMixin, NewsletterMixin, NewsletterTypesMixin
  ],

  created () {
    this.$on('searchResultClicked', this.attachPuzzle)
    this.$forceUpdate()

    this.get()
  },

  methods: {
    attachPuzzle (puzzle) {
      puzzle.pending = true

      this.$store.commit('EmailModule/storeEmailPuzzle', puzzle)
    },

    detachPuzzle (puzzle) {
      if (
        confirm(
          'Are you sure you want to remove this puzzle from this newsletter? ' +
          'Changes will be saved upon submitting the form.'
        )
      ) {
        this.email.puzzles = this.email.puzzles.filter(puz => puz.id !== puzzle.id)
      }
    },

    get () {
      const action = this.emailId ? this.retrievalMethod : this.initializeMethod

      return this.$store.dispatch(
        `EmailModule/${action}`, this.emailId
      ).catch(this.$root.processErrors).finally(() => {
        this.$store.dispatch(
          `SettingModule/getSettings`
        ).catch(this.$root.processErrors)

        this.setDefaultSendAts()
      })
    },

    addPuzzlePlayerLink (ev) {
      let textarea = document.getElementById(ev.target.dataset.textEle)
      let startPos = textarea.selectionStart
      let endPos = textarea.selectionEnd

      const linkHTML = `<span class="email-only"><a href="https://${this.settings.server_name}/puzzles/${this.email.puzzles[0].id}" class="puzzle-player-lbl">Solve this Puzzle Online!</a> (${this.settings.brand_name} login credentials required)</span>`
      textarea.value = [
        textarea.value.substring(0, startPos),
        linkHTML,
        textarea.value.substring(endPos, textarea.value.length)
      ].join('')

      textarea.focus()
      textarea.setSelectionRange(startPos, startPos + linkHTML.length)
    },

    submit (ev) {
      const method = this.emailId ? 'update' : 'create'
      const action = `${method}${this.displayName}`

      this.$store.dispatch(
        `EmailModule/${action}`, new FormData(ev.target)
      ).then(() => {
        const name = this.isEmail ? 'email' : 'newsletter'

        this.$router.push({
          name: name,
          params: {
            [name + 'Id']: this.email.id,
            prepConfirmEmail: true
          }
        })

        FlashStore.result(`This ${this.relationalIdName} has been ${method}d.`)
      }).catch(this.$root.processErrors)

      ev.preventDefault()
    },

    getLocalDateTimeAt (dt) {
      return new Date(dt || Date.now())
    },

    newAttachment (e) {
      e.preventDefault()

      let attach = document.querySelectorAll('.' + this.modelInputId('attachment'))[0].cloneNode()
      attach.style.display = 'inline-block'
      document.querySelector('#' + this.modelInputId('attachments')).appendChild(attach)
    },

    processErrors (e) {
      this.loading = false
      this.$parent.processErrors(e)
    },

    setSendAt () {
      const sendAtDate = document.getElementById(this.modelInputId('send-at-date')).value
      const sendAtTime = document.getElementById(this.modelInputId('send-at-time')).value

      const epoch = Date.parse(sendAtDate + ' ' + sendAtTime)
      let d = new Date(epoch)
      // const sendAt = this.$root.dateTimeFmt(d)

      this.$store.commit('EmailModule/storeSendAt', d)
    },

    setDefaultSendAts () {
      this.defaultSendAtDate()
      this.defaultSendAtTime()
    },

    defaultSendAtDate () {
      const d = this.getLocalDateTimeAt(this.email.send_at || this.now)

      this.$refs.sendAtDate.value = this.$root.localDateInputFmt(d)
    },

    defaultSendAtTime () {
      const d = this.getLocalDateTimeAt(this.email.send_at || this.now)

      this.$refs.sendAtTime.value = this.$root.localTimeInputFmt(d)
    }
  }
}
</script>

<style scoped>
#accordion {
  margin-bottom: 1em;
}

#accordion .card button {
  color: #000;
  font-weight: 300;
  font-size: 1.1em;
  text-decoration: none;
}

.pending {
  background-color: #D0F5E5
}
</style>



// WEBPACK FOOTER //
// src/components/EmailForm.vue